// Environment Configuration Test
// This file can be used to test environment configuration

import { environment, apiBaseUrl, appTitle, debug, isLocal, isDev, isStaging, isProduction } from './environment';

// Test function to log environment information
export const testEnvironmentConfig = () => {
  console.log('🧪 Environment Configuration Test:');
  console.log('=====================================');
  console.log('Environment:', environment.env);
  console.log('API Base URL:', apiBaseUrl);
  console.log('App Title:', appTitle);
  console.log('Debug Mode:', debug);
  console.log('Is Local:', isLocal);
  console.log('Is Dev:', isDev);
  console.log('Is Staging:', isStaging);
  console.log('Is Production:', isProduction);
  console.log('=====================================');
  
  // Test environment-specific logic
  if (isLocal) {
    console.log('✅ Running in local environment');
  } else if (isDev) {
    console.log('✅ Running in development environment');
  } else if (isStaging) {
    console.log('✅ Running in staging environment');
  } else if (isProduction) {
    console.log('✅ Running in production environment');
  } else {
    console.log('❌ Unknown environment');
  }
};

// Auto-run test in development
if (debug) {
  testEnvironmentConfig();
} 